import { useEffect, useState } from 'react'
import { endpoints } from '../constants'
import { Job } from '../interfaces'

export const useTrackingDetailsApi = (
    customer: string,
    trackingId: string,
    submitCount: number,
) => {
    const [job, setJob] = useState<Job>()
    const [isLoading, setIsLoading] = useState(false)
    const [isStarted, setIsStarted] = useState(false)
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false)
            setIsLoading(true)
            setIsStarted(true)
            let response
            let jobs
            try {
                response = await fetch(
                    endpoints.trackingDetails(customer, trackingId),
                )
                jobs = await response.json()
                setJob(jobs[0])
            } catch (error) {
                setIsError(true)
                setJob(undefined)
            }
            setIsLoading(false)
        }
        setJob(undefined)
        if (customer && trackingId) {
            fetchData()
        }
    }, [customer, trackingId, submitCount])

    return { job, isLoading, isStarted, isError }
}
